import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_effect } from '@/hooks/_base/use_effect';
import { use_slice_ui } from '@/hooks/store/use_slices';
import { LOCAL__ui_generation_output_image_preview_set } from '@/state/ui/generation/LOCAL__ui_generation_output_image_preview_set';
import { DTO__image_asset } from '@shared/dto/+image/image_asset_base/DTO__image_asset';

export function WATCHER__image_asset_prevew_reset() {
  const dispatch = use_dispatch();
  const { global__is_app_on_focus, g_output__image_asset_preview } = use_slice_ui(['g_output__image_asset_preview', 'global__is_app_on_focus']);

  use_effect(() => {
    try_reset_preview();
  }, [global__is_app_on_focus]);

  function try_reset_preview() {
    if (global__is_app_on_focus) return;
    if (g_output__image_asset_preview.is_stub()) return; //already empty

    dispatch(LOCAL__ui_generation_output_image_preview_set(DTO__image_asset.CREATE_STUB()));
  }

  return null;
}
